<div class="ds ds-dialog ds-dialog--{{ data.type || 'confirm' }}">
	<div class="ds-dialog__head">
		<span class="ds-dialog__icon"><mat-icon>{{ icon }}</mat-icon></span>
		<div class="ds-dialog__titles">
			<h2 class="ds-dialog__title">{{ data.title }}</h2>
			<p class="ds-dialog__sub" *ngIf="data.subtitle">{{ data.subtitle }}</p>
		</div>
	</div>

	<div class="ds-dialog__body" *ngIf="data.message">{{ data.message }}</div>

	<div class="ds-dialog__footer">
		<button *ngIf="!data.hideCancel" type="button" class="btn btn-ghost" (click)="dialogRef.close(false)">{{ data.cancelText }}</button>
		<button type="button" class="btn" [ngClass]="data.confirmTone === 'danger' ? 'btn-danger' : 'btn-primary'" (click)="dialogRef.close(true)">{{ data.confirmText }}</button>
	</div>
</div>
